<template>
  <sui-page>
    <sui-page-header title="QuickLink"></sui-page-header>
    <sui-page-contents>
      <div style="display:flex;align-items: self-end;">
        <div class="quicklink_box">
        <div class="quicklink_header">
          <div class="tit">Quick Link</div>
          <div class="close"></div>
        </div>
        <div class="quicklink_list">
          <div class="tit">환경</div>
          <ul class="sublist">
            <li>화학물질정보시스템</li>
            <li>한국화학물질관리협회</li>
            <li>한국산업안전보건공단</li>
            <li>국가위험물 정보 시스템</li>
            <li>화학물질정보시스템</li>
            <li>화학물질정보시스템</li>
            <li>화학물질정보시스템</li>
            <li>화학물질정보시스템</li>
            <li>화학물질정보시스템</li>
            <li>화학물질정보시스템</li>
          </ul>
        </div>
        <div class="quicklink_more">
          <p>더보기</p>
        </div>
      </div>
        <div class="mrR30" />
        <div class="quicklink_box">
          <div class="quicklink_header">
            <div class="tit">Quick Link</div>
            <div class="close"></div>
          </div>
          <div class="quicklink_list">
            <div class="tit">환경</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
            <div class="tit">화학물질</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
            <div class="tit">방재</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
            <div class="tit">녹색경영</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
            <div class="tit">온실가스</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
            <div class="tit">공통</div>
             <ul class="sublist">
               <li>화학물질정보시스템</li>
               <li>한국화학물질관리협회</li>
               <li>한국산업안전보건공단</li>
               <li>국가위험물 정보 시스템</li>
               <li>화학물질정보시스템</li>
            </ul>
         </div>
       </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'quicklink_pop',
  data() {
    return {
      // Codes

    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped>
.quicklink_box {
  display: block;
  overflow: hidden;
  width:254px;
  z-index: 100;
  border: 1px solid #ccc;
  background: #fff;
  -webkit-box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.07);
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.07);
  white-space: nowrap;
}
.quicklink_header {display:inline-flex;width:100%}
.quicklink_header .tit {font-size:11px;color:#5a5a5a;line-height:30px;margin-left:15px}
.quicklink_header .close {
  justify-content: flex-end;
  margin-left:auto;
  cursor:pointer;
  width:16px;
  height:30px;
  margin-right:10px;
  background: url('../../assets/images/ic_tooltip_close_normal.png') no-repeat center right;}
.quicklink_list {
  overflow-y: auto;
  overflow-x: hidden;
  max-height:642px;
}
.quicklink_list .tit {
  font-size:13px;
  color:#333;
  font-weight:bold;
  line-height:28px;
  margin:0 15px;
  border-bottom:1px solid #ccc}
.quicklink_list .sublist {font-size:13px;color:#333;padding:0 15px}
.quicklink_list .sublist li {line-height:28px}
.quicklink_list .sublist li:hover {background:url('../../assets/images/ic_quicklink.png') no-repeat center right #f7f7f7;cursor:pointer;}
.quicklink_more {border-top:1px solid #eaeaea;height:28px;cursor:pointer;}
.quicklink_more p {font-size:12px;color:#5a5a5a;text-align:center;line-height:28px}
</style>
